/*eslint-disable no-shadow*/
jQuery(function () {
    var garden = $('.garden-map__garden');
    if (garden.length < 1) {
        return;
    }
    var gardenImage = $('.garden-map__garden-image');
    var wasteBasket = $('.garden-map__waste-basket');
    var mapInfoItems = $('.garden-plan__map-info-items');
    var mapInfoWrapper = $('.garden-plan__map-info');
    var plantSelection = $('.garden-map__plant-selection');
    var plantedTypes = [];
    gardenImage.on('load', function () {
        var imageHeight = $(this).height();
        garden.css('height', imageHeight);
    }).each(function () {
        if (this.complete) {
            $(this).trigger('load');
        }
    });
    $(document).ready(function () {
        //Make element draggable
        $('.js-draggable-plant').draggable({
            revert: 'invalid',
            helper: 'clone',
            //When first dragged
            stop: function (ev, ui) {
                //When an existiung object is dragged
                $('.js-draggable-planted').draggable({
                    revert: 'invalid',
                    drag: function (ev, ui) {
                        plantSelection.css('position', 'relative');
                        wasteBasket.css('display', 'flex');
                    },
                    stop: function (ev, ui) {
                        var positionX = 100 * $(this).position().left / garden.innerWidth();
                        var positionY = 100 * $(this).position().top / garden.innerHeight();
                        $(this).css({ left: positionX + '%', top: positionY + '%' });
                        $(this).find('.input-position-x').val(convertToSweDecimal(positionX));
                        $(this).find('.input-position-y').val(convertToSweDecimal(positionY));
                        plantSelection.css('position', 'static');
                        wasteBasket.hide();
                    }
                });
            }
        });
        $('.js-draggable-planted').draggable({
            revert: 'invalid',
            drag: function (ev, ui) {
                plantSelection.css('position', 'relative');
                wasteBasket.css('display', 'flex');
            },
            stop: function (ev, ui) {
                var positionX = 100 * $(this).position().left / garden.innerWidth();
                var positionY = 100 * $(this).position().top / garden.innerHeight();
                $(this).css({ left: positionX + '%', top: positionY + '%' });
                $(this).find('.input-position-x').val(convertToSweDecimal(positionX));
                $(this).find('.input-position-y').val(convertToSweDecimal(positionY));
                plantSelection.css('position', 'static');
                wasteBasket.hide();
            }
        });
        //Make element droppable
        $('.js-droppable-garden').droppable({
            tolerance: 'fit',
            drop: function (ev, ui) {
                if (ui.helper.attr('data-planted') === undefined) {
                    var element = $(ui.draggable).clone();
                    element.attr('data-planted', 'true');
                    element.addClass('tempclass draggable-planted js-draggable-planted').removeClass('js-draggable-plant');
                    $(this).append(element);
                    var positionX = 100 * (ui.position.left - garden.offset().left) / garden.innerWidth();
                    var positionY = 100 * ui.position.top / garden.innerHeight();
                    element.css({ left: positionX + '%', top: positionY + '%' });
                    var $InputPlantId = $('<input>', {
                        'type': 'hidden',
                        'name': 'MappedPlants[].PlantId',
                        'value': element.attr('data-plant-id')
                    });
                    var $InputPositionX = $('<input>', {
                        'type': 'hidden',
                        'class': 'input-position-x',
                        'name': 'MappedPlants[].PositionX',
                        'value': convertToSweDecimal(positionX)
                    });
                    var $InputPositionY = $('<input>', {
                        'type': 'hidden',
                        'class': 'input-position-y',
                        'name': 'MappedPlants[].PositionY',
                        'value': convertToSweDecimal(positionY)
                    });
                    element.append($InputPlantId, $InputPositionX, $InputPositionY);
                    var plantId = element.data('plant-id');
                    if (garden.find("[data-plant-id='" + plantId + "']").length < 2) {
                        plantedTypes.push(plantId);
                        addListItem(element, plantId);
                    }
                    var $blob = $('<span>', { 'class': 'info-item-identifier' }).text($.inArray(plantId, plantedTypes) + 1);
                    element.append($blob);
                    addDraggablePlantedHoverFunction();
                    mapInfoWrapper.removeClass('hidden');
                }
                $('.js-garden-map-empty-btn').addClass('active');
            }
        });
        wasteBasket.droppable({
            tolerance: 'fit',
            accept: '.draggable-planted',
            drop: function (event, ui) {
                var plantDot = ui.draggable;
                var plantId = plantDot.data('plant-id');
                if (garden.find("[data-plant-id='" + plantId + "']").length < 2) {
                    mapInfoItems.find("[data-plant-id='" + plantId + "']").remove();
                    plantedTypes.splice($.inArray(plantId, plantedTypes), 1);
                    updatePlantInfo();
                }
                removeDraggablePlantHover(plantDot);
                plantDot.remove();
                if (garden.children('.draggable-planted').length < 1) {
                    $('.js-garden-map-empty-btn').removeClass('active');
                    mapInfoWrapper.addClass('hidden');
                }
            },
        });
        initPlantInfo();
        $(window).on('resize', function () {
            var imageHeight = gardenImage.height();
            garden.css('height', imageHeight);
        });
        $('.js-garden-map-empty-btn').on('click', function () {
            if (garden.children('.draggable-planted').length > 0) {
                garden.children('.draggable-planted').remove();
                mapInfoItems.empty();
                plantedTypes = [];
                mapInfoWrapper.addClass('hidden');
                $(this).removeClass('active');
            }
        });
    });
    $('#garden-map-form').submit(function (ev) {
        var $allPlanted = $('.draggable-planted');
        $allPlanted.each(function (i, x) { return addIndexOnSubmit(i, x); });
    });
    function convertToSweDecimal(pos) {
        return (pos / 100).toString().replace('.', ',');
    }
    function addIndexOnSubmit(index, planted) {
        var $planted = $(planted);
        var plantIdInput = $planted.find('input[name=\'MappedPlants[].PlantId\']').first();
        plantIdInput.attr('name', 'MappedPlants[' + index + '].PlantId');
        plantIdInput.val(plantIdInput.val().toString().replace('type-', ''));
        var plantPositionIdInput = $planted.find('input[name=\'MappedPlants[].PlantPositionId\']').first();
        plantPositionIdInput.attr('name', 'MappedPlants[' + index + '].PlantPositionId');
        var positionXInput = $planted.find('input[name=\'MappedPlants[].PositionX\']').first();
        positionXInput.attr('name', 'MappedPlants[' + index + '].PositionX');
        var positionYInput = $planted.find('input[name=\'MappedPlants[].PositionY\']').first();
        positionYInput.attr('name', 'MappedPlants[' + index + '].PositionY');
    }
    function initPlantInfo() {
        var plants = garden.find('.draggable-planted');
        if (plants.length < 1) {
            return;
        }
        else {
            $.each(plants, function () {
                var plantId = $(this).attr('data-plant-id');
                if (plantedTypes.indexOf(plantId) < 0) {
                    plantedTypes.push(plantId);
                    addListItem($(this), plantId);
                }
            });
            updatePlantInfo();
            addDraggablePlantedHoverFunction();
            mapInfoWrapper.removeClass('hidden');
        }
    }
    function addListItem(element, plantId) {
        var $li = $('<li>', { 'class': 'garden-plan__map-info-item', 'data-plant-id': plantId });
        var $number = $('<span>', { 'class': 'info-item-identifier' }).text(($.inArray(plantId, plantedTypes) + 1) + '.');
        var $name = $('<span>').text(element.data('plant-name') + ' - ');
        var $date = $('<span>', { 'class': 'italic' }).text(element.data('plant-date'));
        mapInfoItems.append($li.append($number).append($name).append($date));
    }
    function updatePlantInfo() {
        $.each(plantedTypes, function (index, item) {
            var plantId = item.valueOf();
            garden.find("[data-plant-id='" + plantId + "']").children('.info-item-identifier').text(index + 1);
            mapInfoItems.find("[data-plant-id='" + plantId + "']").children('.info-item-identifier').text(index + 1 + '.');
        });
    }
    function addDraggablePlantedHoverFunction() {
        $('.draggable-planted').hover(function () {
            var plantId = $(this).data('plant-id');
            garden.find("[data-plant-id='" + plantId + "']").addClass('hover');
            mapInfoItems.find("[data-plant-id='" + plantId + "']").addClass('hover');
        }, function () {
            removeDraggablePlantHover($(this));
        });
        $('.garden-plan__map-info-item').hover(function () {
            var plantId = $(this).data('plant-id');
            garden.find("[data-plant-id='" + plantId + "']").addClass('hover');
            mapInfoItems.find("[data-plant-id='" + plantId + "']").addClass('hover');
        }, function () {
            removeDraggablePlantHover($(this));
        });
    }
    function removeDraggablePlantHover(plantDot) {
        var plantId = plantDot.data('plant-id');
        garden.find("[data-plant-id='" + plantId + "']").removeClass('hover');
        mapInfoItems.find("[data-plant-id='" + plantId + "']").removeClass('hover');
    }
});
/*eslint-enable*/
